<eze-modal #modal (onOpen)="onModalOpen()">
	<eze-modal-header>
		<h1>Checkout</h1>
	</eze-modal-header>
	<eze-modal-content>
		<eze-alert></eze-alert>

		<h3>Price: {{ price | currency }}</h3>

		<form
			class="smart-form"
			novalidate
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
		>
			<div class="row">
				<div class="col-xs-12">
					<eze-input-container label="Card Number">
						<input
							ezeInput
							type="text"
							id="cardNumber"
							formControlName="cardNumber"
							[showValidation]="showValidation"
							[textMask]="{
								mask: getCardMask('cardNumber'),
								guide: false
							}"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-4">
					<eze-input-container>
						<select
							ezeInput
							id="month"
							formControlName="month"
							[showValidation]="showValidation"
						>
							<option value="">Select...</option>
							<option
								*ngFor="let month of months"
								[value]="month.number"
								>{{ month.month }}</option
							>
						</select>
					</eze-input-container>
				</div>

				<div class="col-xs-4">
					<eze-input-container>
						<select
							ezeInput
							id="year"
							formControlName="year"
							[showValidation]="showValidation"
						>
							<option value="">Select...</option>
							<option *ngFor="let year of years" [value]="year">{{
								year
							}}</option>
						</select>
					</eze-input-container>
				</div>
				<div class="col-xs-4">
					<eze-input-container label="Card Code">
						<input
							ezeInput
							type="text"
							id="cardCode"
							formControlName="cardCode"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-12">
					<eze-input-container label="Full Name On Card">
						<input
							ezeInput
							type="text"
							id="fullName"
							formControlName="fullName"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<div class="col-xs-4">
					<eze-input-container label="Zip">
						<input
							ezeInput
							type="text"
							id="zip"
							formControlName="zip"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>
			</div>

			<button type="subimit" style="display: none;"></button>
		</form>
	</eze-modal-content>
	<eze-modal-footer>
		<eze-button
			(click)="modal.close()"
			context="default"
			style="margin-right: 10px;"
		>
			Cancel
		</eze-button>
		<eze-button (click)="onSubmit()" context="success">
			Submit Payment
		</eze-button>
	</eze-modal-footer>
</eze-modal>
